import {FeatureGate} from 'common/report/constants';
import type {CurrentProject} from 'common/report/model-resources/projects';

export function hasAccessToFeatureFlagsApp(currentProject?: CurrentProject): boolean {
  if (!currentProject) {
    return false;
  }
  return !!currentProject.getFeatureGate(FeatureGate.FeatureFlagsApp);
}
